import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Collapse,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { styled, keyframes } from "@mui/material/styles";
import logo from "../../assets/reeflogo.jpg";
// import image1 from "../../assets/newvideobanner.mp4";
// import image2 from "../../assets/updatedBannerImage/REEF-49.jpg";
// import image3 from "../../assets/bannerimage2.jpeg";
// import image4 from "../../assets/updatedBannerImage/IMG_3368.jpg";
import image1 from "../../assets/banner-new1.jpg.jpeg";
import image2 from "../../assets/banner-new2.jpg";
import image3 from "../../assets/banner-new3.jpg.jpeg";
import image4 from "../../assets/banner-new4.jpg";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

const Root = styled("div")({
  display: "flex",
  height: "550px", // Reduced from 100vh
  fontFamily: "Montserrat, Helvetica, Arial, Lucida, sans-serif",
  overflow: "hidden",
  position: "relative",
  "@media (max-width: 768px)": {
    flexDirection: "column",
    height: "350px", // Reduced for mobile
  },
});



// const RightPanel = styled(Box)({
//     flex: 1,
//     height: "100vh",
//     overflow: "hidden",
//     position: "relative",
//     zIndex: 1,
//     "@media (max-width: 768px)": {
//         width: "100%",
//         height: "calc(100dvh - 56px)",
//         order: 1,
//     },
// });

const ripples = new Array(3).fill(null);

// Ensures container uses full viewport height
const RightPanel = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  height: "550px", // Reduced from 100vh
  width: "100%",
  backgroundColor: "#000",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    position: "relative",
    width: "100%",
    height: "350px",
    marginTop: 0,
  },
}));

const ScrollContainer = styled("div")(({ theme }) => ({
  display: "flex",
  overflowX: "auto",
  overflowY: "hidden",
  scrollSnapType: "x mandatory",
  scrollBehavior: "smooth",
  height: "100%",
  width: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    height: "100%",
    width: "100%",
  },
}));

const ScrollItem = styled("div")({
  flex: "0 0 100%",
  scrollSnapAlign: "start",
  height: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
});

const ScrollImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover", // Changed from fill to cover
  display: "block",
  margin: 0,
  padding: 0,
});

const ArrowButton = styled(IconButton)(({ theme, side }) => ({
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  [side]: 55,
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  color: "#333",
  zIndex: 10,
  width: "50px",
  height: "50px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "#fff",
    color: "#c62828",
    transform: "translateY(-50%) scale(1.1)",
  },
  [theme.breakpoints.down("sm")]: {
    width: "35px",
    height: "35px",
    [side]: 10,
  },
}));

const DotsContainer = styled("div")({
  position: "absolute", // position over image
  bottom: 20, // 20px from bottom
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 10,
  zIndex: 10,
  pointerEvents: "auto",
});

const Dot = styled("div")(({ active }) => ({
  width: 12,
  height: 12,
  borderRadius: "50%",
  cursor: "pointer",
  backgroundColor: active ? "#fff" : "rgba(255,255,255,0.5)",
  transition: "background-color 0.3s ease",
}));

const OverlayContent = styled(Box)({
  maxWidth: "500px",
  textAlign: "center",
  padding: "20px",
  position: "relative",
});

const fadeSlideUp = keyframes`
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 0; transform: translateY(0); }
`;

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollRef = useRef(null);
  const theme = useTheme();

  const images = [
    { id: 1, src: image1, alt: "Image 1" },
    { id: 2, src: image2, alt: "Image 2" },
    { id: 3, src: image3, alt: "Image 3" },
    { id: 4, src: image4, alt: "Image 4" },
  ];

  useEffect(() => {
    const container = scrollRef.current;
    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % images.length;
      setCurrentIndex(nextIndex);
      container.scrollTo({
        left: container.clientWidth * nextIndex,
        behavior: "smooth",
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  useEffect(() => {
    const container = scrollRef.current;
    const handleScroll = () => {
      const newIndex = Math.round(container.scrollLeft / container.clientWidth);
      setCurrentIndex(newIndex);
    };
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScrollY = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScrollY);
    return () => window.removeEventListener("scroll", handleScrollY);
  }, []);

  const handleDotClick = (index) => {
    const container = scrollRef.current;
    setCurrentIndex(index);
    container.scrollTo({
      left: container.clientWidth * index,
      behavior: "smooth",
    });
  };

  const handlePrev = () => {
    const nextIndex = (currentIndex - 1 + images.length) % images.length;
    handleDotClick(nextIndex);
  };

  const handleNext = () => {
    const nextIndex = (currentIndex + 1) % images.length;
    handleDotClick(nextIndex);
  };

  const RippleWrapper = styled(Box)({
    position: "fixed",
    top: "40px",
    left: "40px",
    zIndex: 15,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const LogoWrapper = styled(Box)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  });

  // const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  const navigate = useNavigate();
  const Header = styled(AppBar)(({ scrolled }) => ({
    backgroundColor: scrolled ? "black" : "transparent",
    boxShadow: "none",
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 11,
    transition: "background-color 0.3s ease",
  }));

  return (
    <>
      <Root sx={{ mt: { xs: -2, md: 0 } }}>


        <RightPanel sx={{ flex: "1", width: "100%" }}>
          <ScrollContainer ref={scrollRef}>
            {images.map((img) => (
              <ScrollItem key={img.id}>
                {img.src.endsWith(".mp4") ? (
                  <video
                    src={img.src}
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <ScrollImage src={img.src} alt={img.alt} />
                )}
              </ScrollItem>
            ))}
          </ScrollContainer>

          {/* Navigation Arrows */}
          <ArrowButton side="left" onClick={handlePrev}>
            <ArrowBackIosNewIcon />
          </ArrowButton>
          <ArrowButton side="right" onClick={handleNext}>
            <ArrowForwardIosIcon />
          </ArrowButton>

          <DotsContainer>
            {images.map((_, idx) => (
              <Dot
                key={idx}
                active={currentIndex === idx}
                onClick={() => handleDotClick(idx)}
              />
            ))}
          </DotsContainer>
        </RightPanel>
      </Root>
    </>
  );
}

export default App;
